import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=4086412d&scoped=true&"
import script from "./Orders.vue?vue&type=script&lang=ts&"
export * from "./Orders.vue?vue&type=script&lang=ts&"
import style0 from "./Orders.vue?vue&type=style&index=0&id=4086412d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4086412d",
  null
  
)

export default component.exports